import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Text, UnorderedList, ListItem} from '@chakra-ui/react'
import {capitalize} from '../../../utils/utils'
import {PRODUCT_ATTRIBUTES} from '../../../constants'

const ProductAttributesList = ({product}) => {
    const productStyle = product?.c_orliweb_product_model || ''
    const productModel = product?.c_model || ''
    const productColorInfo = product?.c_colorInfo || ''

    return (
        <UnorderedList styleType="none" color="darkGray" fontSize="md" margin={0}>
            {productStyle && (
                <ListItem key="style">
                    <FormattedMessage {...PRODUCT_ATTRIBUTES.style} />:{' '}
                    <Text as="span">{capitalize(productStyle)}</Text>
                </ListItem>
            )}

            {productModel && (
                <ListItem key="model">
                    <FormattedMessage {...PRODUCT_ATTRIBUTES.model} />:{' '}
                    <Text as="span">{productModel}</Text>
                </ListItem>
            )}

            {productColorInfo && (
                <ListItem key="color">
                    <FormattedMessage {...PRODUCT_ATTRIBUTES.color} />:{' '}
                    <Text as="span">{productColorInfo}</Text>
                </ListItem>
            )}
        </UnorderedList>
    )
}

ProductAttributesList.propTypes = {
    product: PropTypes.object.isRequired
}

export default ProductAttributesList
